import { FC } from 'react';
import { Typography } from '@mui/material';
import Modal from 'components/Base/Modal';

export type TAlertDialogProps = {
  open: boolean;
  title: string;
  text: string;
  submitLoading?: boolean;
  submitDisabled?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'default';
};

const AlertDialog: FC<TAlertDialogProps> = ({
  open,
  title,
  text,
  submitDisabled,
  submitLoading,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'default',
}) => {
  if (!open) return null;

  const getButtonColor = () => {
    switch (variant) {
      case 'danger':
        return 'error';
      case 'warning':
        return 'warning';
      default:
        return 'primary';
    }
  };

  return (
    <Modal
      handleClose={onCancel}
      open={open}
      title={title}
      maxWidth="xs"
      submitButtonProps={{
        autoFocus: true,
        disabled: submitDisabled,
        loading: submitLoading,
        onClick: onConfirm,
        text: confirmText,
        color: getButtonColor(),
      }}
    >
      <Typography
        variant="body1"
        sx={{
          color: 'text.primary',
          lineHeight: 1.6,
        }}
      >
        {text}
      </Typography>
    </Modal>
  );
};

export default AlertDialog;
